module.exports = __webpack_public_path__ + "static/media/semiconductors.f7d6e97c.jpg";